export { default } from './GridPlaceCategories.vue'
